class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("keyup", (evt) => evt.code === "Escape" && this.close());
    this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    if (window.location.pathname === "/cart") {
      this.cartUpsells = document.querySelector("#cart-upsells");
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink?.setAttribute("role", "button");
    cartLink?.setAttribute("aria-haspopup", "dialog");
    cartLink?.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink?.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
        if (containerToTrapFocusOn && focusElement) {
          trapFocus(containerToTrapFocusOn, focusElement);
        }
      },
      { once: true },
    );

    if (typeof gtag !== "undefined") {
      gtag("event", "user_interaction", {
        link_text: "",
        link_target: "",
        event_category: "User Click",
        event_type: "Open Cart Drawer",
      });
    }

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute("aria-controls", cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
    });

    if (typeof gtag !== "undefined") {
      console.log("Closed header drawer");

      gtag("event", "user_interaction", {
        link_text: "",
        link_target: "",
        event_category: "User Click",
        event_type: "Close Cart Drawer",
      });
    }

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState, shouldOpenPanel = true) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");

    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      if (section) {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        console.log("Rendering section:", section.id, sectionElement);
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    });

    if (shouldOpenPanel) {
      setTimeout(() => {
        this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));

        /* Prevents opening the drawer on the cart page.  */
        if (window.location.pathname !== "/cart") {
          this.open();
        }

        document.querySelector("#js-gift-open")?.addEventListener("click", (e) => {
          document.querySelector("gift-drawer").open();
        });
      });
    }
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    const testHTML = new DOMParser().parseFromString(html, "text/html");

    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  async updateContentsAndOpen() {
    const config = fetchConfig("javascript");

    /* Sections that are important to updating the cart. */
    const updateSections = this.getSectionsToRender().map((section) => section.id);

    const formData = new FormData(this.form);

    formData.append("sections", updateSections);

    config.body = formData;

    /* Shouldn't matter, but using root just in case a URL doesn't have a cart for whatever reason. */
    return await fetch(`/?sections=${updateSections}`)
      .then((response) => response.json())
      .then((response) => {
        const tempObj = {};
        tempObj.sections = response;
        this.renderContents(tempObj);
        this.classList.remove("is-empty");
        this.querySelector(".drawer__inner").classList.contains("is-empty") &&
          this.querySelector(".drawer__inner").classList.remove("is-empty");
      })
      .finally(() => {
        return true;
      })
      .catch((e) => {
        return false;
      });
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        section: document.getElementById("CartDrawer")?.dataset.id,
        selector: "#CartDrawer .drawer__inner",
      },
      {
        id: "cart-icon-bubble",
      },
      {
        id: "gift-drawer",
        section: document.getElementById("cart-rewards-drawer")?.dataset.id,
        selector: ".rewards__offers",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    /*     console.log("CartItems getSectionsToRender");
     */
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-rewards-drawer",
        section: document.getElementById("cart-rewards-drawer")?.dataset.id,
        selector: ".rewards__offers",
      },
      {
        id: "CartDrawer",
        section: document.getElementById("CartDrawer")?.dataset.id,
        selector: "cart-drawer-items",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
